// Tracks the last few designs someone opened, entirely in localStorage —
// no table, no query, purely a per-device convenience like "recent searches".
import { RECENTLY_VIEWED_KEY as STORAGE_KEY } from "./storageKeys";

const MAX_ITEMS = 12;

export function getRecentlyViewed() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    // localStorage is externally mutable (devtools, extensions, a stale
    // shape from a future/older version of this code) — Search.jsx calls
    // .map() straight on this, which would throw and crash the page if
    // what's actually stored under this key isn't an array.
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function addRecentlyViewed(design) {
  if (!design?.id) return;

  try {
    const existing = getRecentlyViewed().filter(d => d.id !== design.id);
    const entry = {
      id: design.id,
      title: design.title || "",
      image_url: design.images?.[0] || design.image_url || "",
      username: design.users?.username || "",
      user_id: design.user_id || null,
      verified: design.users?.verified || false
    };
    const updated = [entry, ...existing].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // localStorage unavailable (private mode, etc.) — just skip tracking.
  }
}
